/**
 * kuusi_kenttaa.v1 — the six fields and the cell marks, the display's copy of
 * apps/backend/src/modules/kuusi_kenttaa_v1/fields.js and grid.js (a module
 * keeps its own copy; the backend is the source of truth and the API carries
 * the field list and the marks too).
 */
export const FIELDS = ['kohdejoukko', 'sijainti', 'omistaja', 'rajoite', 'kokeiltu', 'vastaskenaario'];

export const MARKS = { filled: '●', suggested: '◐', open: '○' };

/** The socket resource the backend names on instance-content-changed when an answer is written. */
export const RESOURCE = 'kuusi_kenttaa';

export const COLORS = {
  bg: '#0b0d12',
  card: '#141821',
  border: '#232a36',
  borderHover: '#3a4457',
  text: '#e8ecf2',
  muted: '#98a2b3',
  dim: '#7b8794',
  filled: '#6fd3c8',
  suggested: '#f2c14e',
  open: '#3a4457',
  error: '#FF8A85',
};
